import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/site/Header";
import Hero from "@/components/site/HeroStage";
import Experience from "@/components/site/Experience";
import Benefits from "@/components/site/Benefits";
import PrivateSession from "@/components/site/PrivateSession";
import Pricing from "@/components/site/Pricing";
import RedLight from "@/components/site/RedLight";
import HowItWorks from "@/components/site/HowItWorks";
import PedalPop from "@/components/site/PedalPop";
import Safety from "@/components/site/Safety";
import Access from "@/components/site/Access";
import LocationSection from "@/components/site/LocationSection";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";

function App() {
  return (
    <div className="App" id="top">
      <Header />
      <main>
        <Hero />
        <Experience />
        <Benefits />
        <PrivateSession />
        <Pricing />
        <RedLight />
        <HowItWorks />
        <PedalPop />
        <Safety />
        <Access />
        <LocationSection />
        <FinalCTA />
      </main>
      <Footer />
      <Toaster position="bottom-center" theme="dark" toastOptions={{ style: { background: "#141414", border: "1px solid #242424", color: "#fafafa", borderRadius: 0 } }} />
    </div>
  );
}

export default App;
